import { PaginationProps } from '@cinch/oxd-components/pagination/src/pagination.component'
import tokens from '@cinch/oxd-utils/tokens/src/tokens'
import React from 'react'
import Media from 'react-media'
import { connect } from 'react-redux'
import { Dispatch } from 'redux'
import { change, FormAction } from 'redux-form'

import Pagination from '@cinch/oxd-components/pagination/src'
import { FORM_NAME } from '@cinch/oxd-containers/dealer-listing-filters/src'

import * as styles from './vehicle-results-pagination.module.css'

/**
 * TODO add selectors for vehicle listing entity
 */
export const mapStateToProps = (state: any) => {
  return {
    activePage: state.entities.dealerListings.pageNumber,
    totalItemsCount: state.entities.dealerListings.searchResultsCount,
    itemsCountPerPage: state.entities.dealerListings.pageSize,
  }
}

export const mapDispatchToProps = (dispatch: Dispatch<FormAction>) => ({
  onChange: (pageNumber: number) => {
    dispatch(change(FORM_NAME, 'pageNumber', pageNumber))
  },
})

const { m } = tokens.customMedia

const VehiclePagination: React.FC<any> = (props) => (
  <nav role="navigation" aria-label="Pagination" className={styles.pagination}>
    <Media defaultMatches={true} query={m}>
      {(matches) => {
        const mobileProps = {} as Partial<PaginationProps>

        if (!matches) {
          mobileProps.hideDisabled = true
          mobileProps.pageRangeDisplayed = 2
        }

        return <Pagination {...props} {...mobileProps} hideFirstLastPages={true} />
      }}
    </Media>
  </nav>
)

export default connect<{ activePage: number; totalItemsCount: number }, { onChange: any }, any, any>(
  mapStateToProps,

  mapDispatchToProps,
)(VehiclePagination)
